'use client';

import { isRichTextEditorEnabled } from '@/constants';

import {
  RichTextPlainFallback,
  RichTextPlateShell,
} from './rich-text-plate-shell';
import type { RichTextInputProps } from './rich-text-shared';

export type RichTextFieldProps = RichTextInputProps;

/** Short-form markdown field (bio, org about) — Preview | Markdown switch, compact surface. */
export function RichTextField({
  frame = 'field',
  ...props
}: RichTextFieldProps) {
  if (!isRichTextEditorEnabled()) {
    return <RichTextPlainFallback {...props} chrome="field" frame={frame} />;
  }

  return <RichTextPlateShell {...props} chrome="field" frame={frame} />;
}
